import React from 'react';
import Button from 'Modals/components/Button';
import PropTypes from 'prop-types';
import { closeModal } from 'Modals/ModalActions';
import { updateSignatureActiveButton, expandFreeWriteAddSignatureSection } from 'SignatureManager/SignatureManagerActions';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestFreeWriteExport } from 'EditorOverlay/EditorOverlayActions';

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    closeModal,
    updateSignatureActiveButton,
    expandFreeWriteAddSignatureSection,
    requestFreeWriteExport,
  }, dispatch)
);

export class SignatureReminderModalBodyContent extends React.Component {

  constructor() {
    super();
    this.state = {
      response: null,
      cancelReason: '',
      selection: null,
    };
    this.expandSignatureSection = this.expandSignatureSection.bind(this);
    this.continueWithoutSigning = this.continueWithoutSigning.bind(this);
  }

  componentDidMount() {
    window.localStorage.setItem('signatureAdded', 1);
    window._track('Viewed Signature Reminder', 'My Documents');
  }

  continueWithoutSigning() {
    this.props.closeModal(this.props.modalType);
    this.props.requestFreeWriteExport();
    window._track('Continue Without Signing | Viewed Signature Reminder', 'My Documents');
  }

  expandSignatureSection() {
    this.props.closeModal(this.props.modalType);
    this.props.expandFreeWriteAddSignatureSection('type');
    window._track('Sign Now | Viewed Signature Reminder', 'My Documents');
  }

  render() {
    return (
      <div className="signature-reminder">
        <button className="modal-close-btn" onClick={this.continueWithoutSigning} />
        <img className="signature-reminder-image" src={`${window.cdnUrl}/images/signature-reminder/signature-reminder-2x.png`} alt="Signature" />
        <h4>Do you need to sign this document?</h4>
        <p>Type, draw or add a signature to make your document official.</p>
        <div className="buttons">
          <Button
            buttonOnClick={this.expandSignatureSection}
            buttonText="Sign Now"
            trackCategory={this.state.response}
            trackAction="My Documents"
            type="submit"
          />
          <button
            className="continue-without-signing-btn"
            onClick={this.continueWithoutSigning}
          >
            Continue without signing
          </button>
        </div>
      </div>
    );
  }
}

SignatureReminderModalBodyContent.defaultProps = {
  modalType: '',
};

SignatureReminderModalBodyContent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalType: PropTypes.string,
  expandFreeWriteAddSignatureSection: PropTypes.func.isRequired,
  requestFreeWriteExport: PropTypes.func.isRequired,
};

const ConnectedSignatureReminderModalBody = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(SignatureReminderModalBodyContent);
export default ConnectedSignatureReminderModalBody;



// WEBPACK FOOTER //
// ./src-react/Modals/content/SignatureReminderBodyContent.jsx